import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShovel, faTruckMoving } from '@fortawesome/pro-duotone-svg-icons';

import { updateSite, refreshReferential } from '../app/updateApp';
import DropDownSite from '../sites/components/DropDownSite';
import Footbar from '../sites/components/FootBar';

import AskMaterial from '../sites/components/AskMaterial';
import SiteSupply from '../sites/components/SiteSupply';
import { hasAccessToMaterial, hasAccessToSupply } from '../../utils/access';

const Supply = () => {
    const { t } = useTranslation();
    const siteState = useSelector(state => state.sites);

    const [module, setModule] = useState(hasAccessToSupply() ? 'supply' : 'material');

    useEffect(function () {
        refreshReferential().then(() => updateSite(siteState.selectedSite));
    }, []);

    return (
        <div className="module-page module-supply">
            <DropDownSite />
            <div className="type-selector" style={{marginTop: '32px'}}>
                {hasAccessToSupply() && <div
                    onClick={() => setModule('supply')}
                    className={module === 'supply' ? 'selected' : ''}
                >
                    <FontAwesomeIcon icon={faTruckMoving} />
                    {t('common:supply')}
                </div>}
                {hasAccessToMaterial() && <div
                    onClick={() => setModule('material')}
                    className={module === 'material' ? 'selected' : ''}
                >
                    <FontAwesomeIcon icon={faShovel} />
                    {t('common:ask_material')}
                </div>}
            </div>
            { module === 'supply' && <SiteSupply /> }
            { module === 'material' && <AskMaterial/> }
            <Footbar />
        </div>
    );
};

export default Supply;

